import { getCookie } from "./cookies.ts";
import { sSessionStorage } from "./localStorage.ts";

/**
 * Retrieves the Solvari session ID from session storage.
 * @returns Session ID string or null
 * @example const sessionId = getSolvariSessionId();
 */
function getSolvariSessionId() {
  return sSessionStorage.getItem("solvariSession");
}

/**
 * Retrieves the Solvari client ID from cookies.
 * @returns Client ID string or null
 * @example const clientId = getSolvariClientId();
 */
function getSolvariClientId() {
  return getCookie("solvariClientId", false);
}

export { getSolvariClientId, getSolvariSessionId };
